import React from 'react'
import './ArticleCard.css'
import code from '../../assets/code.png'
export default function ArticleCard({article,img}) {
    return (
            <div className="grid__item">
                <div className="card__article">
                <div className="card__media">
                <img src={img} />
                </div>
                    <div className="card__article__content">
                        <h1 className="card__article__header">{article.title}</h1>
                        <p className="card__article__text">
                            {article.body}
                            </p>
                        </div>
                </div>
            </div>
    )
}
